import { useEffect, useState } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchTrackingPixels } from '@services/index';
import { PaginatedResponse } from '@app/types/common';
import { TrackingPixel } from '@account_module/types/Integration';
import { FEATURE_FLAG, useFeatureFlag } from '@auth_module/hooks/useFeatureFlag';

export const useInfiniteTrackingPixels = () => {
  const { isEnabled: isMegaphoneTrackingPixelEnabled } = useFeatureFlag(
    FEATURE_FLAG.MEGAPHONE_TRACKING_PIXEL
  );
  const [totalTrackingPixels, setTotalTrackingPixels] = useState<number>(0);
  const [trackingPixels, setTrackingPixels] = useState<TrackingPixel[]>([]);

  const { data, isLoading, isFetchingNextPage, isInitialLoading, fetchNextPage, hasNextPage } =
    useInfiniteQuery({
      queryKey: ['megaphone-campaign-orders'],
      queryFn: ({ pageParam }) => fetchTrackingPixels({ page: pageParam, pageSize: 500 }),
      getNextPageParam: ({ pagination, pageParam }) => {
        const { total, page_size } = pagination;
        const hasMore = total / page_size > pageParam;
        return hasMore ? pageParam + 1 : undefined;
      },
      getPreviousPageParam: ({ pageParam }) => {
        return pageParam > 1;
      },
      keepPreviousData: true,
      staleTime: 60 * 60 * 1000, // 1h
      enabled: isMegaphoneTrackingPixelEnabled,
    });

  useEffect(() => {
    if (data?.pages?.length) {
      setTotalTrackingPixels(data.pages[0].pagination.total);
      const arr: TrackingPixel[] = [];
      data.pages?.forEach((element: PaginatedResponse<TrackingPixel>) => {
        element.data.map((item: TrackingPixel) => arr.push(item));
      });

      setTrackingPixels(arr);
    } else {
      setTrackingPixels([]);
    }
  }, [data?.pages]);

  return {
    trackingPixels,
    totalTrackingPixels,
    isLoading,
    isLoadingMore: isFetchingNextPage,
    isInitialLoading,
    hasNextPage,
    fetchNextPage,
  };
};
